import { useState } from "react";

const useMessage = () => {
  const [opensnack, setOpensnack] = useState(false);
  const [typesnackbar, setTypeSnackBar] = useState("error");
  const [message, setMessage] = useState("");

  const handleClosesSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpensnack(false);
  };
  const handleMuestraSnack = (mensaje, tipomensaje) => {
    setMessage(mensaje);
    setTypeSnackBar(tipomensaje);
    setOpensnack(true);
  };

  return {
    opensnack,
    typesnackbar,
    message,
    handleMuestraSnack,
    handleClosesSnack
  };
};

export default useMessage;
